import { BfwUserContextService, PagedWishlistItems } from 'generatedBfw/static';

export const fetchWishlistItemsPaginated = async (offset = 0): Promise<PagedWishlistItems> => {
  // TODO: wishlist items are temporary on BFW, so this is also a temporary solution. Should be reworked when going for prod with wishlist.
  return await BfwUserContextService.getWishlistItems(offset, 12);
};
